__turbopack_context__.v({
  "inside": "IconGrid-module__Tq9uRW__inside",
  "wrapper": "IconGrid-module__Tq9uRW__wrapper",
});
